// extracted by mini-css-extract-plugin
export default {"LayoutCardMap":"layout-card-map_LayoutCardMap__R437s"};